import "./ThePartnership.module.css";
import Header from "@/reusable_sections/Header";
import TheMuseCollective from "./sections/TheMuseCollective";
import WhyShopWithUs from "./sections/WhyShopWithUs";
import Footer from "@/reusable_sections/Footer";
export default function ThePartnershipPage() {
  return <div>
      <Header />
      <TheMuseCollective />
      <WhyShopWithUs />
      <Footer />
    </div>;
}